import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

export default function HomePage(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Padstow Insider</title>
        <meta
          name="description"
          content="Your personal Padstow companion. Local picks, in your pocket."
        />
      </Helmet>
      <main
        id="main"
        className="container-narrow safe-top safe-bottom flex min-h-dvh flex-col justify-center"
      >
        <div className="animate-slide-up">
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full bg-moor-700 text-white">
            <Compass aria-hidden="true" className="h-7 w-7" />
          </div>
          <h1 className="font-display text-4xl text-moor-800 sm:text-5xl">
            Padstow Insider
          </h1>
          <p className="mt-3 text-lg text-slate-700">
            Hello Padstow. Morwenna's almost ready.
          </p>
          <p className="mt-6 text-sm text-slate-600">
            We're stitching the harbour, the headland and the hidden bits together. Back any minute.
          </p>
          {/*
            Sign-in CTA for the new-device recovery path. A user who
            joined Padstow on one device and opens the app on a second
            (or after clearing site data) lands here with no
            personalPage in localStorage and no Clerk session. The
            target /sign-in route renders Clerk's hosted SignIn
            component; on magic-link return, OnboardingCompletePage
            rehydrates personalPage from /v1/users/me and routes back
            to /me. Phrasing is explicit about "another device" so
            fresh visitors who haven't joined don't get nudged into
            sign-in by mistake.
          */}
          <div className="mt-10 border-t border-moor-100 pt-6">
            <p className="text-sm text-slate-600">
              Already joined from another device?{' '}
              <Link
                to="/sign-in"
                className="rounded-sm font-medium text-moor-700 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-moor-500/40 focus-visible:ring-offset-2"
              >
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </main>
    </>
  );
}
